<template>
  <v-container class="pa-0 news-content">
    <h1 class="content-title">News</h1>

    <v-progress-circular v-if="refreshing" indeterminate></v-progress-circular>
    <div v-else>
      <!-- <hcm-card
        v-for="n in news"
        :key="n.uuid"
        :resource="n"
        :resourceType="'news'"
      ></hcm-card> -->
      <hcm-news-card
        v-for="n in news()"
        :key="n.uuid"
        :resource="n"
      ></hcm-news-card>
    </div>
  </v-container>
</template>

<script>
import { orderBy } from "lodash";
import HCMNewsCard from "../components/HCMNewsCard.vue";

export default {
  components: { "hcm-news-card": HCMNewsCard },
  methods: {
    news() {
      return orderBy(
        this.$store.get(`newsItems`),
        o => {
          return o.postingDate;
        },
        "desc"
      );
    }
  },
  created() {
    console.log("news");
    this.refreshData();
    this.pageTrack(this.$router.currentRoute.path, "News Feed");
  },
  computed: {
    analyticsOn() {
      return this.$store.get("analyticsOn");
    }
  },
  watch: {
    analyticsOn: function(val) {
      if (val) {
        this.pageTrack(this.$router.currentRoute.path, "News Feed");
      }
    }
  }
};
</script>

<style scoped>
.content-title {
  color: #ffffff;
  border-bottom: 1px solid #ffffff;
  font-weight: bold;
  font-size: 26px;
  padding-bottom: 10px;
  margin: 20px 0px;
  text-shadow: 0 1px 1px #5a6566;
}

.news-content {
  max-width: 690px;
}
</style>
